<div class="wrapper-promotions">
    <div class="section-title row">
        <div class="section-btn">
            <button class="btn btn-back" routerLink="../overview" [attr.aria-label]="'Back' | translate">
                <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <div>
            <div class="title" [attr.data-parent]="'Dashboard' | translate">{{ "Automatic Discounts" | translate }}</div>
        </div>
    </div>
    <div class="section-action">
        <div *ngIf="!loading" class="d-flex justify-content-end w-100 mt-sm">
            <button (click)="togglehidden()" class="btn" [class]="{
                'btn-blue-small':voucherList.length != 0, 'btn-freeze-small':voucherList.length == 0
            }">{{ "Add Discount" | translate }}</button>
        </div>
    </div>

    <div class="section-main mt-4"  *ngIf="selectVoucherShow">
        <div class="table-stores3 table-responsive mx-auto px-4 pt-3 pb-5" style="overflow-y: hidden;">
            <form>

                <div class="d-flex flex-column col-12 col-lg-12 mt-4">
                    <!-- <label class="form-label">Select Voucher</label> -->
                    <h4 class="title-2 mt-2">{{ "Select Voucher" | translate }}</h4>
                    <div ngbDropdown class="d-inline-block row">
                        <div class="row ml-0">
                            <div class="col-12 col-lg-6">
                                <i class="arrow down"></i>
                                <button *ngIf="!selectedVoucer" id="dropdownBasic1" ngbDropdownToggle class="btn btn-outline-primary text-left w-100">{{ "Please select" | translate }}...</button>
                                <button *ngIf="selectedVoucer" class="btn btn-outline-primary text-left w-100" id="dropdownBasic1" ngbDropdownToggle aria-expanded="false" >
                                    {{ selectedVoucer }}
                                </button>
                            </div>
                            <div class="col-12 col-lg-6">
                                <button class="btn btn-blue-small ml-3 mt-1 mb-5" (click)="addDiscount(selectedVoucerId)">{{ "Save" | translate }}</button>
                                <button class="btn btn-red-small ml-3 mt-1 mb-5" (click)="togglehidden()">{{ "Cancel" | translate }}</button>
                            </div>
                        </div>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="col-12 col-lg-6">
                            <!-- <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown dropdown-menu"> -->
                                <button *ngFor="let voucher of promotionList" ngbDropdownItem (click)="selectVoucher(voucher.promotion_name, voucher.promotion_id, voucher.promotion_action_product)">
                                    <img width="40" [src]="voucher.images">
                                    <span class="ml-2">{{ voucher.promotion_name }}</span>
                                </button>
                            <!-- </div> -->
                        </div>
                        
                    </div>
                </div>
    
                
                <div *ngIf="selectedVoucer !=''" class="d-flex flex-column col-12 col-lg-12">
                    <div class="alert-message">* <i>{{ "The selected voucher can be used only once." | translate }}</i></div>
                    <div *ngFor="let promotion of actionProductList" class="voucher-content">                        
                        <div class="voucherName">{{promotion.product_name}}</div>                        
                        <div *ngIf="promotion.fixed_qty" class="voucherQty">{{promotion.qty}}</div>
                        <div *ngIf="!promotion.fixed_qty">
                                <select class="voucherDropDown" #number (change)="selectActionQty(number.value, promotion.p_id)">
                                    <option *ngFor="let q of getArrayRange(promotion.qty+1); index as i" [value]="i">{{i}}</option>
                                </select>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    </div>

    <div class="section-action mb-5">
        <div class="d-flex flex-column flex-lg-row align-items-lg-center">
            <span class="mr-2">{{ "Filters" | translate }}: </span>
            <div class="d-flex flex-column flex-lg-row">
                <!-- <div class="form-group product-name-filter mb-0">
                    <input type="text" class="form-control" [(ngModel)]="productNameFilter" placeholder="Filter by discount name">
                </div> -->
                <div class="ml-lg-2 mb-2 my-lg-0">
                    <div ngbDropdown class="d-inline-block w-100">
                        <button class="btn btn-outline-primary w-100" id="dropdownBasic2" ngbDropdownToggle> {{ selectedStatus || 'Country' | translate }}</button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="custom-dropdown">
                            <button ngbDropdownItem *ngFor="let filter of statusFilters" (click)="filterCountry(filter)">{{ filter.display | translate }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-main">
        <div class="table-stores table-responsive mx-auto">
            <table class="table">
                <thead>
                    <tr>
                        <th class="text-center">
                            {{ "Discount Name" | translate }}
                        </th>
                        <th class="text-center">
                            {{ "Country" | translate }}
                        </th>
                        <!-- <th class="text-center">
                            {{ "Amount" | translate }}
                        </th> -->
                        <th class="text-center">
                            {{ "Action" | translate }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngIf="discounts.length == 0 && !loading">
                        <td colspan="8" class="border-left-0 border-right-0 pb-4 text-center no-records">{{ "No Record found" | translate }}</td>
                    </tr>
                    <tr *ngIf="loading">
                        <td class="border-left-0 border-right-0 pb-4 text-center" colspan="8">
                            <div class="loading-spinner col-12">
                                <mat-spinner class="mx-auto my-3" [diameter]="50"></mat-spinner>
                            </div>
                        </td>
                    </tr>
                    <tr *ngFor="let p of promotion">
                        <td>
                            <img width="40" [src]="p.images">
                            <span class="ml-2">{{ p.promotion_name }}</span>
                        </td>
                        <td class="text-center">{{ p.country }}
                            <span class="country flag-icon-background"
                                [ngClass]="'flag-icon-' + getFlagByCountryCode(p.country_code)"></span>
                        </td>
                        <!-- <td class="text-center">{{p.currency_symbol}} {{ getValue(p.retail_price[1]) }}</td> -->
                        <td class="d-flex justify-content-center mb-3">
                            <div>
                                <button (click)="open(content, p.promotion_id)" class="btn btn-red-small btn-sm">>{{ "Delete" | translate }}</button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">{{ "Delete Discount" | translate }}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div class="text-secondary">{{ "Are you sure you want to delete this Discount?" | translate }}</div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="modal.close('Save click')">{{ "Cancel" | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="modal.close('delete')">{{ "Delete" | translate }}</button>
    </div>
</ng-template>

<ng-template #success let-modal>
    <div class="modal-body text-center">
        <div class="row" align="center" >
            <div class="col pt-4 pt-lg-0">
                <h4>{{ "Successfully Update" | translate }}</h4>
            </div>
        </div>
        <button  class="btn btn-primary" type="button" name="button" (click)="modal.close('Send click')  ">{{ "Close" | translate }}</button>
    </div>
</ng-template>
